import { Component } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-dashboard-chart-bar',
  standalone: false,
  templateUrl: './dashboard-chart-bar.component.html',
  styleUrl: './dashboard-chart-bar.component.scss'
})
export class DashboardChartBarComponent {

  options: EChartsOption = {
    tooltip: {},
    xAxis: { data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'] },
    yAxis: {},
    series: [{
      type: 'bar',
      data: [120, 200, 150, 80, 190, 220]
    }]
  };

}
